import { useTranslation } from 'react-i18next';
import { store } from 'src/state/dynamic-store';
import { useSelector } from 'react-redux';
import { RootState } from '@state/root-state.ts';
import { OrganizationDetailPageWrapper } from './OrganizationDetailPageWrapper';
import useOrganizationPermissions from '@hooks/permissions/useOrganizationPermissions';
import { CdfBreadcrumbs } from '@commonComponents/navigation/CdfBreadcrumbs';
import styles from './OrganizationsPage.module.scss';

export function OrganizationsPage() {
  const { t } = useTranslation(['layouts']);
  const licenseOwnerId = useSelector((state: RootState) => state.appContext.selectedLicenseOwnerId ?? '');
  const organizationId = useSelector((state: RootState) => state.appContext.selectedOrganizationId ?? '');
  const { writePermission, readPermission } = useOrganizationPermissions(organizationId);

  if (!licenseOwnerId) {
    return null;
  }

  return (
    <div className={styles.pageContainer}>
      <CdfBreadcrumbs items={[{ label: t('breadCrumbs.organizations.page') }]} />
      <div className={styles.contentContainer}>
        <OrganizationDetailPageWrapper
          organizationId={organizationId}
          licenseOwnerId={licenseOwnerId}
          store={store}
          writePermission={writePermission}
          readPermission={readPermission}
        />
      </div>
    </div>
  );
}
